// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CheckDefault } from '../../../assets/icons/default/general/check.svg?react';
import { ReactComponent as CheckSolid } from '../../../assets/icons/solid/general/CHECK.svg?react';
import { createIcons } from '../../Icon';
const CheckIcon = /* @__PURE__ */ createIcons('Check', {
    default: CheckDefault,
    solid: CheckSolid
});
CheckIcon.supportedTypes = ['default', 'solid'];
CheckIcon.category = 'general';
export default CheckIcon;
